import config from '../Config';

export const isSmallModuleView = (componentWidth: number) => {
  return config.isModule && componentWidth < 600;
};
